<template>
  <div id="app" class="app">
    <nav-bar />
    <div class="main-div">
      <router-view />
    </div>
    <footer-bar />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import menu from "@/menu.js";
import NavBar from "@/components/NavBar.vue";
// import AsideMenu from '@/components/AsideMenu.vue'
import FooterBar from "@/components/FooterBar.vue";

export default defineComponent({
  name: "AppComponent",
  components: {
    FooterBar,
    NavBar,
  },
  data() {
    return {
      menu,
    };
  },
  created() {
    console.log(this.$store.state);
  },
  methods: {},
});
</script>
<style lang="scss">
.app {
  margin: 0 auto;
  max-width: 1920px;
}

@media (max-width: 1200px) {
  html {
    width: 100%;
    height: 100%;
    overflow-x: auto;
  }
}

.main-div {
  box-sizing: border-box;
}

.modal {
  z-index: 10000 !important;
}

.no-data {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  img {
    width: 300px;
    height: 300px;
  }

  .no-data-text {
    font-size: 16px;
    color: #999;
    text-align: center;
  }
}
</style>
